module.exports = __webpack_public_path__ + "static/media/Colombia.eaeb40a1.svg";